<div class="page-area">
    <div class="basic-boxes">
        <div class="basic-details basic-details2">
            <div class="basic-title">
                <h5>Department</h5>
            </div>
            <div class="basic-contbox">
                <div class="dep-input-box">
                    <input nz-input placeholder="Main Department" [(ngModel)]="value" />
                    <a href="javascript:void(0);" (dblclick)="open()" class="dep-btn"><span><i nz-icon nzType="plus" nzTheme="outline"></i></span> Add</a>
                </div>
                <div class="dep-input-box">
                    <input nz-input placeholder="Department Name" [(ngModel)]="value" />
                </div>
                <div class="dep-input-box">
                    <input nz-input placeholder="Legal Name" [(ngModel)]="value" />
                </div>
            </div>
            <div class="grace-btnbox">
                <ul>
                    <li><a href="javascript:void();"><span></span> Edit</a></li>
                    <li><a href="javascript:void();"><span></span> Save</a></li>
                    <li><a href="javascript:void();"><span></span> Clear</a></li>
                    <li><a href="javascript:void();"><span></span>Close</a></li>
                </ul>
            </div>
        </div>
        <div class="basic-details basic-details3">
            <div class="tabledata">
                <div class="tabletop-description">
                    <div class="t-description">
                        <h5>Main Department</h5>
                        <a href="#">Print & Export</a>
                    </div>
                </div>
                <nz-table #fixedTable [nzData]="listOfData2" [nzSize]="'small'">
                    <thead>
                        <tr>
                            <th>Departname</th>
                            <th>Legal Name</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data">
                            <td>{{ data.name }}</td>
                            <td>{{ data.age }}</td>
                            <td>{{ data.address }}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
</div>


<nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '0px' }"
    [nzMaskClosable]="false" [nzWidth]="915" [nzVisible]="visible"
    [nzTitle]=" (isEdit ? 'Update' : '') + ' Shift Group'" (nzOnClose)="close()">
    <div class="drawer-content">
        <div class="basic-boxes">
            <div class="basic-details basic-details2">
                <div class="basic-title">
                    <h5>Main Department Master</h5>
                </div>
                <div class="basic-contbox">
                    <div class="basic-cont basic-cont2">
                        <div class="emp-title">
                            <h5>Name</h5>
                        </div>
                        <div class="emp-input">
                            <input nz-input placeholder="Name" [(ngModel)]="value" />
                        </div>
                    </div>

                    <div class="basic-cont basic-cont2">
                        <div class="emp-title">
                            <h5>Short Name</h5>
                        </div>
                        <div class="emp-input">
                            <input nz-input placeholder="Short Name" [(ngModel)]="value" />
                        </div>
                    </div>

                    <div class="grace-btnbox">
                        <ul>
                            <li><a href="javascript:void();"><span></span> Edit</a></li>
                            <li><a href="javascript:void();"><span></span> Save</a></li>
                            <li><a href="javascript:void();"><span></span> Clear</a></li>
                            <li><a href="javascript:void();"><span></span>Close</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="basic-details basic-details3">
                <div class="tabledata2">
                    <nz-table #fixedTable [nzData]="listOfData" [nzSize]="'small'" >
                        <thead>
                            <tr>
                                <th>Weekday</th>
                                <th>Shift Name</th>
                                <th>Shift Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of fixedTable.data">
                                <td>{{ data.name }}</td>
                                <td>{{ data.age }}</td>
                                <td><span><i nz-icon nzType="delete" nzTheme="fill"></i></span></td>
                            </tr>
                        </tbody>
                    </nz-table>
                </div>
            </div>
            
        </div>
    </div>
</nz-drawer>